import { render, staticRenderFns } from "./roundList.vue?vue&type=template&id=072d7a5a&scoped=true&"
import script from "./roundList.vue?vue&type=script&lang=ts&"
export * from "./roundList.vue?vue&type=script&lang=ts&"
import style0 from "./roundList.vue?vue&type=style&index=0&id=072d7a5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d7a5a",
  null
  
)

export default component.exports